'use client';
import { createContext, useContext, useReducer } from 'react';

const initialHealthScreeningState = {
  pet: {
    name: '',
    weight: '',
    activity: '',
    month: '',
    year: '',
    spayedStatus: '',
  },
  imageId: null,
  customer: {
    firstName: 'Pup Parent',
    email: '',
    phoneNumber: '',
    smsOptIn: false,
  },
  existingPetId: null,
};

export const HealthScreeningContextActionName = {
  setPet: 'setPet',
  setImageId: 'setImageId',
  setCustomer: 'setCustomer',
  setExistingPetId: 'setExistingPetId',
};

const reducer = (state, action) => {
  switch (action.type) {
    case HealthScreeningContextActionName.setPet:
      return { ...state, pet: action.payload };
    case HealthScreeningContextActionName.setImageId:
      return { ...state, imageId: action.payload.imageId };
    case HealthScreeningContextActionName.setCustomer:
      return { ...state, customer: action.payload };
    case HealthScreeningContextActionName.setExistingPetId:
      return { ...state, existingPetId: action.payload };
    default:
      return state;
  }
};

export const HealthScreeningContext = createContext(null);

export const useHealthScreening = () => useContext(HealthScreeningContext);

export const HealthScreeningProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialHealthScreeningState);

  const value = {
    ...state,
    dispatch,
  };
  return (
    <HealthScreeningContext.Provider value={value}>
      {children}
    </HealthScreeningContext.Provider>
  );
};
